module.exports = __webpack_public_path__ + "static/img/9.9752cbf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/trainPlan/10sportDesc/9.svg
// module id = i+VT
// module chunks = 0